import { useState } from "react";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { http, API, errMsg } from "../../lib/api";

const field = "w-full rounded-xl border border-cyan-400/20 bg-[#050911] px-4 py-3 text-sm text-white placeholder:text-slate-400 outline-none focus:border-cyan-400/70";

export const SuggestForm = ({ onAdded }) => {
  const [f, setF] = useState({ title: "", description: "", author: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!API) return toast.error("Ideas are temporarily unavailable.");
    setBusy(true);
    try {
      const { data } = await http.post("/ideas/community", f);
      onAdded(data);
      setF({ title: "", description: "", author: "" });
      toast.success("Idea posted. Let the votes roll in.");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} data-testid="suggest-idea-form"
      className="rounded-3xl border border-cyan-400/25 bg-[#0A101D] p-6 sm:p-7">
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#F59E0B]">Pitch your idea</p>
      <h3 className="mt-2 font-display text-3xl font-extrabold uppercase text-white">What should we build?</h3>
      <div className="mt-5 space-y-3">
        <input required minLength={3} maxLength={120} placeholder="Your idea (e.g. Night fishing tournaments)" value={f.title} onChange={set("title")} className={field} data-testid="suggest-idea-title-input" />
        <textarea rows={3} maxLength={1000} placeholder="Tell us more (optional)" value={f.description} onChange={set("description")} className={field} data-testid="suggest-idea-description-input" />
        <input maxLength={40} placeholder="Your name or username (optional)" value={f.author} onChange={set("author")} className={field} data-testid="suggest-idea-author-input" />
      </div>
      <button type="submit" disabled={busy} data-testid="suggest-idea-submit-button"
        className="mt-5 flex items-center gap-2 rounded-full bg-[#00E5FF] px-5 py-2.5 font-mono text-xs font-bold uppercase tracking-[0.12em] text-[#050911] hover:bg-white active:scale-95 transition-[background-color,transform]">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Post idea
      </button>
      <p className="mt-3 text-xs text-slate-400">Keep it friendly. Bad language is automatically censored.</p>
    </form>
  );
};
